import transparentBeforeAnimation from '../lib/transparent-before-animation';
import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import addTranslateYAnimation from '../lib/add-translate-y-animation';

gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.divider-section';
// eslint-disable-next-line no-unused-vars
const sectionCallBack = (sectionElement, query, queryAll) => {
    const divider = query('.divider');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: sectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(divider, timeline);
    addTranslateYAnimation(timeline, divider);
};

export { sectionSelector, sectionCallBack };
